export default __webpack_public_path__ + "static/media/carto-logo.60ee54a6.svg";